import { keyWrapper } from '~publish/helpers/keywrapper'

import generateProfileTabs from './utils'
import type { GenerateProfileTabsInput } from './utils'

export const actionTypes = keyWrapper('PROFILE_NAV', {
  GENERATE_PROFILE_TABS: 0,
})

export type ProfileNavAction = {
  type: string
  profile?: GenerateProfileTabsInput['profile']
  organization?: GenerateProfileTabsInput['organization']
  // This is of type QueueAction TODO: add a new action in the Queue reducer
  counts?: {
    pending: number
    updatesScheduled: number
    draftsScheduled: number
  }
}

export type ProfileNavState = {
  profileNavTabs: string[]
  draftsNeedApprovalCount: number
  draftsCount: number
  draftsScheduledCount: number
  pendingCount: number
  selectedTabId: string | undefined
}

export const initialState: ProfileNavState = {
  profileNavTabs: [],
  draftsNeedApprovalCount: 0,
  draftsCount: 0,
  draftsScheduledCount: 0,
  pendingCount: 0,
  selectedTabId: undefined,
}

export default (
  state = initialState,
  action: ProfileNavAction,
): ProfileNavState => {
  switch (action.type) {
    case actionTypes.GENERATE_PROFILE_TABS: {
      const { profile, organization } = action
      return {
        ...state,
        profileNavTabs: generateProfileTabs({ profile, organization }),
      }
    }

    default:
      return state
  }
}

export const actions = {
  generateProfileTabs: ({
    profile,
    organization,
  }: GenerateProfileTabsInput): {
    type: typeof actionTypes.GENERATE_PROFILE_TABS
    profile: GenerateProfileTabsInput['profile']
    organization: GenerateProfileTabsInput['organization']
  } => ({
    type: actionTypes.GENERATE_PROFILE_TABS,
    profile,
    organization,
  }),
}
